// @ts-nocheck

import { CursorArrowRaysIcon } from '@heroicons/react/24/outline';
import ClientModal from './ClientModal';
import { PageHeader2 } from './PageHeader2';
import { TableClients } from './TableClients';
export const Client = () => {
  const icon = (<CursorArrowRaysIcon></CursorArrowRaysIcon>)
  const button1 = (
    <ClientModal />
  );

/*   const button2 = (

    <Link to={`/admin/parceiros/${id}/taxas`}>
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-md border border-transparent bg-green-cl px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-eupago focus:outline-none focus:ring-2 focus:ring-green-cl focus:ring-offset-2 sm:w-auto"
      >
        Definir Taxas
      </button>
    </Link>
  ); */
  return (
    <>
      <PageHeader2 icons={icon} button1={button1} />
      <TableClients />
    </>
  )
}
export default Client
